// core imports
import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule, Optional, SkipSelf } from '@angular/core';
import { MediaWatcherModule } from '@core/services/media-watcher/media-watcher.module';

/** custom Modules */
import { SplashScreenModule } from '@core/services/splash-screen/splash-screen.module';
import { UtilsModule } from '@core/services/utils/utils.module';
import { DownloadButtonsModule } from '@core/components/download-buttons';
import { SuccessModalModule } from '@core/components/success-modal/success-modal.module';

/** Material config default   */
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from "@angular/material/form-field";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MATERIAL_SANITY_CHECKS } from '@angular/material/core';
export const tooltipConfigDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 100,
  position: 'above',
  touchendHideDelay: 500,
};
export const formConfigDefault: MatFormFieldDefaultOptions = { appearance: 'outline' }

// global interceptors
import { HttpBodyInterceptor } from "@core/interceptors/httpbody.interceptor";
import { HttpHeaderInterceptor } from "@core/interceptors/httpheaders.interceptor";
import { HttpManageErrorInterceptor } from '@core/interceptors/http-manage-error.interceptor';

// globlal services
import { ApiService } from "@core/services/api/api.service";
import { SharedSrvceCbModule } from "@core/services/shared/shared.module";
import { manageStorageService } from "@core/services/manage-storage/manage-storage.service";
import { SwUpdateService } from '@core/services/service-worker/sw-update.service';

/** Manage time && loca adapters */
import localeEsMX from "@angular/common/locales/es-MX"
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MOMENT_DATE_FORMATS } from "@core/adapters/moment-date.adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CurrencyPipe, DatePipe, DecimalPipe, registerLocaleData } from "@angular/common";

registerLocaleData(localeEsMX, 'es-MX')

@NgModule({
  imports: [
    MediaWatcherModule,
    SplashScreenModule,
    UtilsModule,
    DownloadButtonsModule,
    SuccessModalModule,

    //module shared info
    SharedSrvceCbModule,

  ],

  providers: [
    //common providers
    CurrencyPipe, DecimalPipe, DatePipe,
    // manage time session

    // manage call
    ApiService,
    // manage storage
    manageStorageService,
    SwUpdateService,
    // set values default in app modules && components
    { provide: HTTP_INTERCEPTORS, useClass: HttpHeaderInterceptor, multi: true, },
    { provide: HTTP_INTERCEPTORS, useClass: HttpManageErrorInterceptor, multi: true, },
    { provide: HTTP_INTERCEPTORS, useClass: HttpBodyInterceptor, multi: true },
    { provide: MATERIAL_SANITY_CHECKS, useValue: { doctype: true, theme: false, version: true } },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    { provide: LOCALE_ID, useValue: "es-MX" },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'MXN' },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: formConfigDefault },
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: tooltipConfigDefaults },
    { provide: APP_INITIALIZER, useFactory: (swUpdate: SwUpdateService) => function () { swUpdate.initialize(); }, deps: [SwUpdateService], multi: true },
  ],
})

export class CBModule {
  /**
   * Constructor
   */
  constructor(@Optional() @SkipSelf() parentModule?: CBModule) {
    if (parentModule) {
      throw new Error(
        ' CBModule has already been loaded. Import this module in the AppModule only!'
      );
    }
  }
}
